import { lazy } from 'react';
const DataSets = lazy(() => import('../screens/datasets'));
const DataSetsNextEnv = lazy(() => import('../screens/datasets-next-env'));
const PilotageVolume = lazy(() => import('../screens/pilotage-volume'));
const StopRelance = lazy(() => import('../screens/stopRelance'));
const RefCampaigns = lazy(() => import('../screens/refcampaigns'));
const Segment = lazy(() => import('../screens/segments'));
const RefCampaignDetails = lazy(() => import('../screens/refcampaign-details'));
export const basePath = '';

const routes = [
  {
    name: 'dataSets',
    path: `${basePath}/data-sets`,
    component: DataSets,
    roles: ['ROLE_FR'],
  },
  {
    name: 'dataSetsProd',
    path: `${basePath}/data-sets-prod`,
    component: DataSetsNextEnv,
    roles: ['ROLE_FR'],
  },
  {
    name: 'volumes',
    path: `${basePath}/volumes`,
    component: PilotageVolume,
    roles: ['ROLE_FR'],
  },
  {
    name: 'stopRelance',
    path: `${basePath}/stop-relance`,
    component: StopRelance,
    roles: ['ROLE_FR'],
  },
  {
    name: 'refcampaigns',
    path: `${basePath}/refcampaigns`,
    component: RefCampaigns,
    roles: ['ROLE_FR'],
  },
  {
    name: 'refcampaignDetails',
    path: `${basePath}/refcampaigns/:campaignId`,
    component: RefCampaignDetails,
    roles: ['ROLE_FR'],
  },
  {
    name: 'segments',
    path: `${basePath}/segments`,
    component: Segment,
    roles: ['ROLE_FR', 'ROLE_INT'],
  },
];

export const includeRoles = (roles1, roles2) => {
  let refMap = {};

  for (let role of roles1) {
    refMap[role] = true;
  }
  for (let role of roles2) {
    if (refMap[role]) {
      return true;
    }
  }
  return false;
};

const homePageByRoles = {
  ROLE_FR: {
    name: 'home',
    path: '/refcampaigns',
    component: RefCampaigns,
  },
  ROLE_INT: {
    name: 'home',
    path: `${basePath}/`,
    component: Segment,
  },
};

function getHomePage(roles) {
  for (let role in homePageByRoles) {
    if (roles.includes(role)) {
      return homePageByRoles[role];
    }
  }
}

export const getRoutes = (roles) => {
  let accessibleRoute = [];
  for (let route of routes) {
    if (includeRoles(roles, route.roles)) {
      accessibleRoute.push(route);
    }
  }
  accessibleRoute = [getHomePage(roles), ...accessibleRoute];
  return accessibleRoute;
};
